var _ = require("../../../uam/module.js")(module.exports, {
    namespace: "email.uajson",
    title: "Email UA JSON",
    description: "Renders prebuilt HTML or plain text blocks for email templates.",
    supportServer: true,
    control: false,
    foruseIn: ["email"],
    fields: {
        "inner": {
            title: "Inner",
            type: "string",
            description: "HTML or UA/JSON content prepared for email-safe rendering.",
            required: false,
            default: ""
        },
        "text": {
            title: "Text",
            type: "string",
            description: "Optional plain-text fallback.",
            required: false,
            default: ""
        }
    }
});

var $ = require("../../../uam/scafolding.js");

// Sibling element that owns the markup -> readable text/plain conversion. Reused so
// a uajson block with no authored `text` still yields real plain text (see renderEmail).
var emailText = require("./email.text.js");

function normalizeInlineSpacing(html) {
    var content = (html || "").toString();
    // Preserve readability when adjacent inline tags were re-serialized without
    // whitespace (e.g., </strong><u>) after UA/JSON conversion.
    content = content.replace(
        /<\/(strong|em|u|b|i|span|code|small|mark|sub|sup)>\s*<(strong|em|u|b|i|span|code|small|mark|sub|sup)\b/gi,
        "</$1> <$2"
    );
    return content;
}

exports.render = async function (options) {
    var rendered = await exports.renderEmail(options);
    return [{
        n: "ua.element.serverNotSupported",
        inner: {
            n: "json",
            type: "ua/interface",
            by: "email.uajson",
            i: JSON.stringify({
                n: "html",
                html: `<div style="max-width:480px;margin:0 auto;font-family:Arial,Helvetica,sans-serif;">${rendered.html}</div>`
            })
        }
    }];
};

exports.renderEmail = async function (options) {
    var cfg = $.config || {};
    var textColor = (cfg.my && cfg.my.app && cfg.my.app.colors && cfg.my.app.colors.text) || "#000000";

    var contentHtml = (options && options.inner) ? normalizeInlineSpacing(options.inner) : "";
    // Plain-text fallback order: an authored `text` wins; otherwise derive readable
    // plain text from the block's HTML `inner`; otherwise "". NEVER emit a placeholder
    // sentence into the recipient's text/plain part (it shipped as literal inbox copy).
    var plainText;
    if (options && options.text) {
        plainText = options.text;
    } else if (options && options.inner) {
        plainText = emailText.toPlainText(options.inner);
    } else {
        plainText = "";
    }

    var html = `<tr>
  <td style="padding:8px 20px;font-family:Arial,Helvetica,sans-serif;font-size:16px;color:${textColor};line-height:1.6;">
    <div>${contentHtml}</div>
  </td>
</tr>`;

    return { html, text: plainText };
};
